import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column align-center justify-center h-100",
      attrs: { "data-qa": "appointment_preloader" },
    },
    [
      _c(
        "div",
        { staticClass: "my-auto" },
        [
          _c(VProgressCircular, {
            staticClass: "primary--text d-block mb-6 mx-auto",
            attrs: { size: "61", width: "3", indeterminate: "" },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-body-1 text--text text-center",
              attrs: { "data-qa": "appointment_preloader_progress_text" },
            },
            [
              _vm.appointmentPlaceTypes.isTelemed ||
              _vm.appointmentPlaceTypes.isTelemedMedtochka
                ? [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "Открываем ваш личный кабинет — МедТочку",
                            _vm.options
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                : [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("Записываем на прием...", _vm.options)) +
                        "\n      "
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-body-2 text-info--text text-center w-100",
          class: { "mb-6": !_vm.isMobile },
          attrs: { "data-qa": "appointment_preloader_help" },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("Если возникли вопросы, звоните", _vm.options)) +
              "\n    "
          ),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "text-body-2 text-info--text",
              attrs: {
                href: "tel:88007073129",
                "data-qa": "appointment_preloader_phone",
              },
            },
            [_vm._v("8 (800) 707-31-29")]
          ),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("— поможем разобраться", _vm.options)) +
              "\n  "
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }